import React, { useContext, useEffect, useState } from "react";
import { DashboardContext } from "context/DashboardContext";
import { ModalContext } from "context/ModalContext";
import { api_srv } from "services";
import { show_toast } from "utils/helpers";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useQuery } from "react-query";
import { X } from "react-feather";
import Select from "react-select";
import { useQueryClient } from "react-query";

async function get_my_underwriters() {
    let resp = await (await api_srv).fetchAllUnderwriters();
    console.log("myu-", resp);
    return resp.data;
}

async function fetch_subclass() {
    let resp = await (await api_srv).list_subclass();
    console.log("RS res[", resp);
    return resp.data;
}

export default function Add_Product_Underwriter({ fetchUnderwriters , onHide}) {
    const { productUnderwriter, setProductUnderwriter } = useContext(DashboardContext);
    const { modalClose } = useContext(ModalContext);
    const queryClient = useQueryClient()

    const [emails, setEmails] = useState([]);
    const [currentEmail, setCurrentEmail] = useState("");

    const { data: underwriters, isLoading: isMyUnderwritersLoading, isSuccess: isMyUnderwritersSuccess } = useQuery("myunderwriters", get_my_underwriters);
    const { data: subclasses, isLoading: isSubclassLoading, isSuccess: isSubclassSuccess } = useQuery("subclasses", fetch_subclass);

    // Reset irrelevant fields when settlementType changes
    useEffect(() => {
        setProductUnderwriter((prev) => ({
            ...prev,
            mpesaNumber: prev.settlementType === "MPESA" ? prev.mpesaNumber : "",
            paybillNumber: prev.settlementType === "PAYBILL" ? prev.paybillNumber : "",
            accountNumber: prev.settlementType === "PAYBILL" || prev.settlementType === "BANK" ? prev.accountNumber : "",
            bankName: prev.settlementType === "BANK" ? prev.bankName : "",
            branch: prev.settlementType === "BANK" ? prev.branch : "",
        }));
    }, [productUnderwriter?.settlementType, setProductUnderwriter]);

    useEffect(() => {
        console.log("PU===", productUnderwriter);
    });

    // Cleanup on unmount
    useEffect(() => {
        return () => {
            setProductUnderwriter({
                underwriter: "",
                remarks: "",
                allowedToCreateProduct: "no",
                channelType: "MANUAL",
                settlementType: "MPESA",
                mpesaNumber: "",
                paybillNumber: "",
                accountNumber: "",
                bankName: "",
                branch: "",
                settlementFrequency: "EOD",
                threshold: "",
                minimumSettlement: "",
                loading: false,
            });
            setEmails([]);
        };
    }, [setProductUnderwriter]);

    const handleProductUnderwriterChange = (evt, setFieldValue) => {
        const { value, name } = evt.target;
        console.log(`Input changed: ${name} = ${value}`);
        setFieldValue(name, value);
        setProductUnderwriter({
            ...productUnderwriter,
            [name]: value,
        });
    };

    const handleInsuranceClassChange = (classRef, setFieldValue, values) => {
        const updatedClasses = values.insuranceClasses.includes(classRef)
            ? values.insuranceClasses.filter((ref) => ref !== classRef)
            : [...values.insuranceClasses, classRef];
        setFieldValue("insuranceClasses", updatedClasses);
    };

    // IMPROVED addEmail: auto-add on blur/enter, better feedback
    const addEmail = () => {
        const trimmedEmail = currentEmail.trim();

        if (!trimmedEmail) {
            show_toast("Email cannot be empty", "warning");
            return;
        }

        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail)) {
            show_toast("Please enter a valid email", "error");
            return;
        }

        if (emails.includes(trimmedEmail)) {
            show_toast("Email already added", "warning");
            setCurrentEmail("");
            return;
        }

        setEmails([...emails, trimmedEmail]);
        setCurrentEmail("");
        show_toast("Email added", "success");
    };

    const removeEmail = (emailToRemove) => {
        setEmails(emails.filter((email) => email !== emailToRemove));
    };

    const addProductUnderwriter = async (values, { setSubmitting, resetForm }) => {
        console.log("Submitting form with values:", values);
        setProductUnderwriter({ ...productUnderwriter, loading: true });

        const payload = {
            underwriterSystemRef: values.underwriter,
            allowedToCreateProducts: values.allowedToCreateProduct === "yes",
            allowedInsurances: "",
            settlementFrequency: "",
            minimumSettlementAmount: "",
            isEnabled: true,
            settlementChannel: values.settlementType,
            settlementChannelDetails: {
                bankname: values.settlementType === "BANK" ? values.bankName : "",
                bankbranch: values.settlementType === "BANK" ? values.branch : "",
                accountnumber: values.settlementType === "BANK" || values.settlementType === "PAYBILL" ? values.accountNumber : "",
                mpesaNumber: values.settlementType === "MPESA" ? values.mpesaNumber : "",
                paybillNumber: values.settlementType === "PAYBILL" ? values.paybillNumber : "",
            },
            internalUnderwriterRef: values.remarks,
            emails: emails,
            insuranceClasses: values.insuranceClasses,
            channelType: values.channelType,
            settlementFrequency: values.settlementFrequency,
            threshold: values.settlementFrequency === "THRESHOLD" ? Number(values.threshold) : 0,
            minimumSettlement: Number(values.minimumSettlement),
        };

        console.log("Sending payload:", payload);

        try {
            let resp = await (await api_srv).configureUnderwriter(payload);
            console.log("API response:", resp);
            setProductUnderwriter({
                underwriter: "",
                remarks: "",
                allowedToCreateProduct: "no",
                channelType: "MANUAL",
                settlementType: "MPESA",
                mpesaNumber: "",
                paybillNumber: "",
                accountNumber: "",
                bankName: "",
                branch: "",
                settlementFrequency: "EOD",
                threshold: "",
                minimumSettlement: "",
                loading: false,
            });
            setEmails([]);
            resetForm();
            fetchUnderwriters();
            
            queryClient.invalidateQueries({ queryKey: ['underwriters'] });

            onHide();
            show_toast(`Product Underwriter added`, "success");
        } catch (err) {
            console.error("Error adding product underwriter:", err);
            setProductUnderwriter({ ...productUnderwriter, loading: false });
            show_toast(`Failed to add product underwriter: ${err.message || "An unexpected error occurred"}`, "error");
        } finally {
            setSubmitting(false);
        }
    };

    const validationSchema = Yup.object().shape({
        underwriter: Yup.string().required("Please select an underwriter"),
        remarks: Yup.string().required("Remarks are required"),
        minimumSettlement: Yup.number()
            .typeError("Minimum settlement must be a number")
            .required("Minimum settlement is required")
            .positive("Minimum settlement must be a positive number"),
        allowedToCreateProduct: Yup.string().required("Please specify if allowed to create product"),
        channelType: Yup.string().required("Channel type is required"),
        settlementType: Yup.string().required("Settlement type is required"),
        mpesaNumber: Yup.string().when("settlementType", {
            is: "MPESA",
            then: Yup.string().required("M-Pesa number is required"),
            otherwise: Yup.string().notRequired(),
        }),
        paybillNumber: Yup.string().when("settlementType", {
            is: "PAYBILL",
            then: Yup.string().required("Paybill number is required"),
            otherwise: Yup.string().notRequired(),
        }),
        accountNumber: Yup.string().when("settlementType", {
            is: (val) => val === "PAYBILL" || val === "BANK",
            then: Yup.string().required("Account number is required"),
            otherwise: Yup.string().notRequired(),
        }),
        bankName: Yup.string().when("settlementType", {
            is: "BANK",
            then: Yup.string().required("Bank name is required"),
            otherwise: Yup.string().notRequired(),
        }),
        branch: Yup.string().when("settlementType", {
            is: "BANK",
            then: Yup.string().required("Branch is required"),
            otherwise: Yup.string().notRequired(),
        }),
        settlementFrequency: Yup.string().required("Settlement frequency is required"),
        threshold: Yup.number()
            .typeError("Threshold must be a number")
            .when("settlementFrequency", {
                is: "THRESHOLD",
                then: Yup.number()
                    .required("Threshold amount is required when threshold frequency is selected")
                    .positive("Threshold must be a positive number"),
                otherwise: Yup.number().notRequired(),
            }),
        insuranceClasses: Yup.array()
            .min(1, "At least one insurance class must be selected")
            .required("Insurance classes are required"),
    });

    return (
        <div className="p-4 bg-white rounded">
            {isMyUnderwritersLoading && <div className="text-center py-4">Loading underwriters...</div>}
            {isMyUnderwritersSuccess && (
                <Formik
                    enableReinitialize
                    initialValues={{
                        underwriter: productUnderwriter?.underwriter || "",
                        remarks: productUnderwriter?.remarks || "",
                        minimumSettlement: productUnderwriter?.minimumSettlement || "",
                        allowedToCreateProduct: productUnderwriter?.allowedToCreateProduct || "no",
                        channelType: productUnderwriter?.channelType || "MANUAL",
                        settlementType: productUnderwriter?.settlementType || "MPESA",
                        mpesaNumber: productUnderwriter?.mpesaNumber || "",
                        paybillNumber: productUnderwriter?.paybillNumber || "",
                        accountNumber: productUnderwriter?.accountNumber || "",
                        bankName: productUnderwriter?.bankName || "",
                        branch: productUnderwriter?.branch || "",
                        settlementFrequency: productUnderwriter?.settlementFrequency || "EOD",
                        threshold: productUnderwriter?.threshold || "",
                        insuranceClasses: productUnderwriter?.insuranceClasses || [],
                    }}
                    validationSchema={validationSchema}
                    onSubmit={addProductUnderwriter}
                >
                    {({ errors, touched, values, setFieldValue }) => (
                        <Form className="mb-3">
                            <div className="row g-4">
                                {/* Basic Information Section */}
                                <div className="col-12">
                                    <h5 className="border-bottom pb-2  text-primary">Basic Information</h5>
                                </div>

                                {/* Underwriter Selection */}
                                <div className="col-md-6">
                                    <label htmlFor="underwriter" className="form-label fw-semibold">
                                        Underwriter <span className="text-danger">*</span>
                                    </label>
                                    <select
                                        name="underwriter"
                                        onChange={(e) => handleProductUnderwriterChange(e, setFieldValue)}
                                        value={productUnderwriter?.underwriter || ""}
                                        className={`form-select ${errors.underwriter && touched.underwriter ? "is-invalid" : ""}`}
                                        style={{
                                            padding: "0.75rem",
                                            border: "1px solid #dee2e6",
                                            borderRadius: "0.375rem",
                                            backgroundColor: "#fff",
                                            transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
                                        }}
                                    >
                                        <option value="">Select Underwriter</option>
                                        {underwriters?.map((underwriter) => (
                                            <option key={underwriter.underwriterSystemRef} value={underwriter.underwriterSystemRef}>
                                                {underwriter.name}
                                            </option>
                                        ))}
                                    </select>
                                    <ErrorMessage name="underwriter" component="div" className="invalid-feedback" />
                                </div>

                                {/* Remarks Field */}
                                <div className="col-12">
                                    <label htmlFor="remarks" className="form-label fw-semibold">
                                        Remarks <span className="text-danger">*</span>
                                    </label>
                                    <textarea
                                        name="remarks"
                                        value={productUnderwriter?.remarks || ""}
                                        onChange={(e) => handleProductUnderwriterChange(e, setFieldValue)}
                                        className={`form-control ${errors.remarks && touched.remarks ? "is-invalid" : ""}`}
                                        rows="3"
                                        placeholder="Enter remarks"
                                    />
                                    <ErrorMessage name="remarks" component="div" className="invalid-feedback" />
                                </div>

                                {/* Email Management Section */}
                                <div className="col-12">
                                    <h5 className="border-bottom pb-2 my-3 text-primary">Contact Information</h5>
                                </div>

                                <div className="col-12">
                                    <label htmlFor="email" className="form-label fw-semibold">Email Addresses</label>
                                    <div className="d-flex gap-2 mb-2">
                                        <input
                                            type="email"
                                            value={currentEmail}
                                            onChange={(e) => setCurrentEmail(e.target.value)}
                                            onKeyPress={(e) => {
                                                if (e.key === "Enter") {
                                                    e.preventDefault();
                                                    addEmail();
                                                }
                                            }}
                                            onBlur={() => {
                                                if (currentEmail.trim() && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(currentEmail.trim())) {
                                                    addEmail();
                                                }
                                            }}
                                            className="form-control"
                                            placeholder="Enter email and press Enter or click away"
                                        />
                                        <button
                                            type="button"
                                            onClick={addEmail}
                                            className="btn btn-outline-primary"
                                            disabled={!currentEmail || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(currentEmail)}
                                        >
                                            Add
                                        </button>
                                    </div>

                                    {/* Live validation hint */}
                                    {currentEmail && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(currentEmail) && (
                                        <small className="text-danger">Please enter a valid email</small>
                                    )}

                                    {/* Display Added Emails */}
                                    {emails.length > 0 && (
                                        <div className="mt-2">
                                            <div className="d-flex flex-wrap gap-2">
                                                {emails.map((email, index) => (
                                                    <div
                                                        key={index}
                                                        className="badge bg-primary bg-opacity-10 text-primary d-flex align-items-center gap-2 px-3 py-2 border"
                                                        style={{ fontSize: "0.9rem" }}
                                                    >
                                                        {email}
                                                        <X
                                                            size={16}
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() => removeEmail(email)}
                                                            className="text-muted hover:text-danger"
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                    {/* Optional hint if no emails */}
                                    {emails.length === 0 && (
                                        <small className="text-muted">Add at least one email address</small>
                                    )}
                                </div>

                                {/* Permissions Section */}
                                <div className="col-12">
                                    <h5 className="border-bottom pb-2 my-3 text-primary">Permissions & Settings</h5>
                                </div>

                                {/* Allowed to Create Product Radio Buttons */}
                                <div className="col-md-6">
                                    <label className="form-label fw-semibold">Allowed to Create Product</label>
                                    <div className="d-flex gap-8" style={{ gap: "2rem" }}>
                                        <div className="form-check">
                                            <input
                                                type="radio"
                                                name="allowedToCreateProduct"
                                                value="yes"
                                                checked={values.allowedToCreateProduct === "yes"}
                                                onChange={(e) => handleProductUnderwriterChange(e, setFieldValue)}
                                                className="form-check-input"
                                                id="allowedYes"
                                            />
                                            <label className="form-check-label" htmlFor="allowedYes">Yes</label>
                                        </div>
                                        <div className="form-check">
                                            <input
                                                type="radio"
                                                name="allowedToCreateProduct"
                                                value="no"
                                                checked={values.allowedToCreateProduct === "no"}
                                                onChange={(e) => handleProductUnderwriterChange(e, setFieldValue)}
                                                className="form-check-input"
                                                id="allowedNo"
                                            />
                                            <label className="form-check-label" htmlFor="allowedNo">No</label>
                                        </div>
                                    </div>
                                    <ErrorMessage name="allowedToCreateProduct" component="div" className="invalid-feedback d-block" />
                                </div>

                                {/* Allowed Insurance Classes */}
                                <div className="col-12 my-2">
                                    <label className="form-label fw-semibold">
                                        Allowed Insurance Classes <span className="text-danger">*</span>
                                    </label>
                                    <Select
                                        isMulti
                                        name="insuranceClasses"
                                        options={
                                            isSubclassSuccess && subclasses?.length > 0
                                                ? subclasses.map((subclass) => ({
                                                      value: subclass.code,
                                                      label: subclass.name,
                                                  }))
                                                : []
                                        }
                                        value={values.insuranceClasses.map((code) =>
                                            subclasses?.find((subclass) => subclass.code === code)
                                                ? { value: code, label: subclasses.find((subclass) => subclass.code === code).name }
                                                : null
                                        ).filter(Boolean)}
                                        onChange={(selectedOptions) => {
                                            const selectedValues = selectedOptions ? selectedOptions.map((option) => option.value) : [];
                                            setFieldValue("insuranceClasses", selectedValues);
                                            setProductUnderwriter((prev) => ({
                                                ...prev,
                                                insuranceClasses: selectedValues,
                                            }));
                                        }}
                                        className={`react-select-container ${errors.insuranceClasses && touched.insuranceClasses ? "is-invalid" : ""}`}
                                        classNamePrefix="react-select"
                                        placeholder="Select insurance classes..."
                                        noOptionsMessage={() => "No insurance classes available"}
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                borderColor: errors.insuranceClasses && touched.insuranceClasses ? "#dc3545" : base.borderColor,
                                                "&:hover": {
                                                    borderColor: errors.insuranceClasses && touched.insuranceClasses ? "#dc3545" : base.borderColor,
                                                },
                                            }),
                                        }}
                                    />
                                    <ErrorMessage name="insuranceClasses" component="div" className="invalid-feedback" />
                                </div>

                                {/* Channels Section */}
                                <div className="col-12">
                                    <h5 className="border-bottom pb-2 my-3 text-primary">Channel Configuration</h5>
                                </div>

                                {/* Channels Radio Buttons */}
                                <div className="col-md-6">
                                    <label className="form-label fw-semibold">Channel Type</label>
                                    <div className="d-flex gap-8" style={{ gap: "2rem" }}>
                                        <div className="form-check">
                                            <input
                                                type="radio"
                                                name="channelType"
                                                value="MANUAL"
                                                checked={values.channelType === "MANUAL"}
                                                onChange={(e) => handleProductUnderwriterChange(e, setFieldValue)}
                                                className="form-check-input"
                                                id="manualRadio"
                                            />
                                            <label className="form-check-label" htmlFor="manualRadio">Manual</label>
                                        </div>
                                        <div className="form-check">
                                            <input
                                                type="radio"
                                                name="channelType"
                                                value="AUTOMATIC"
                                                checked={values.channelType === "AUTOMATIC"}
                                                onChange={(e) => handleProductUnderwriterChange(e, setFieldValue)}
                                                className="form-check-input"
                                                id="autoRadio"
                                            />
                                            <label className="form-check-label" htmlFor="autoRadio">Auto</label>
                                        </div>
                                    </div>
                                    <ErrorMessage name="channelType" component="div" className="invalid-feedback d-block" />
                                </div>

                                {/* Settlement Configuration Section */}
                                <div className="col-12">
                                    <h5 className="border-bottom pb-2 my-4 text-primary">Settlement Configuration</h5>
                                </div>

                                {/* Minimum Settlement Field */}
                                <div className="col-md-6">
                                    <label htmlFor="minimumSettlement" className="form-label fw-semibold">
                                        Minimum Settlement <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        name="minimumSettlement"
                                        type="number"
                                        value={productUnderwriter?.minimumSettlement || ""}
                                        onChange={(e) => handleProductUnderwriterChange(e, setFieldValue)}
                                        className={`form-control ${errors.minimumSettlement && touched.minimumSettlement ? "is-invalid" : ""}`}
                                        placeholder="Enter minimum settlement amount"
                                    />
                                    <ErrorMessage name="minimumSettlement" component="div" className="invalid-feedback" />
                                </div>

                                {/* Settlement Type Radio Buttons */}
                                <div className="col-12 py-4">
                                    <label className="form-label fw-semibold">Settlement Type</label>
                                    <div className="d-flex gap-8" style={{ gap: "3rem" }}>
                                        <div className="form-check">
                                            <input
                                                type="radio"
                                                name="settlementType"
                                                value="MPESA"
                                                checked={values.settlementType === "MPESA"}
                                                onChange={(e) => handleProductUnderwriterChange(e, setFieldValue)}
                                                className="form-check-input"
                                                id="mpesaNumberRadio"
                                            />
                                            <label className="form-check-label" htmlFor="mpesaNumberRadio">M-Pesa Number</label>
                                        </div>
                                        <div className="form-check">
                                            <input
                                                type="radio"
                                                name="settlementType"
                                                value="PAYBILL"
                                                checked={values.settlementType === "PAYBILL"}
                                                onChange={(e) => handleProductUnderwriterChange(e, setFieldValue)}
                                                className="form-check-input"
                                                id="paybillRadio"
                                            />
                                            <label className="form-check-label" htmlFor="paybillRadio">Paybill</label>
                                        </div>
                                        <div className="form-check">
                                            <input
                                                type="radio"
                                                name="settlementType"
                                                value="BANK"
                                                checked={values.settlementType === "BANK"}
                                                onChange={(e) => handleProductUnderwriterChange(e, setFieldValue)}
                                                className="form-check-input"
                                                id="bankRadio"
                                            />
                                            <label className="form-check-label" htmlFor="bankRadio">Bank</label>
                                        </div>
                                    </div>
                                    <ErrorMessage name="settlementType" component="div" className="invalid-feedback d-block" />
                                </div>

                                {/* Conditional Input Fields for Settlement Types */}
                                {values.settlementType === "MPESA" && (
                                    <div className="col-md-6">
                                        <label htmlFor="mpesaNumber" className="form-label fw-semibold">
                                            M-Pesa Number <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            name="mpesaNumber"
                                            type="text"
                                            value={productUnderwriter?.mpesaNumber || ""}
                                            onChange={(e) => handleProductUnderwriterChange(e, setFieldValue)}
                                            className={`form-control ${errors.mpesaNumber && touched.mpesaNumber ? "is-invalid" : ""}`}
                                            placeholder="Enter M-Pesa number"
                                        />
                                        <ErrorMessage name="mpesaNumber" component="div" className="invalid-feedback" />
                                    </div>
                                )}

                                {values.settlementType === "PAYBILL" && (
                                    <>
                                        <div className="col-md-6">
                                            <label htmlFor="paybillNumber" className="form-label fw-semibold">
                                                Paybill Number <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                name="paybillNumber"
                                                type="text"
                                                value={productUnderwriter?.paybillNumber || ""}
                                                onChange={(e) => handleProductUnderwriterChange(e, setFieldValue)}
                                                className={`form-control ${errors.paybillNumber && touched.paybillNumber ? "is-invalid" : ""}`}
                                                placeholder="Enter paybill number"
                                            />
                                            <ErrorMessage name="paybillNumber" component="div" className="invalid-feedback" />
                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="accountNumber" className="form-label fw-semibold">
                                                Account Number <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                name="accountNumber"
                                                type="text"
                                                value={productUnderwriter?.accountNumber || ""}
                                                onChange={(e) => handleProductUnderwriterChange(e, setFieldValue)}
                                                className={`form-control ${errors.accountNumber && touched.accountNumber ? "is-invalid" : ""}`}
                                                placeholder="Enter account number"
                                            />
                                            <ErrorMessage name="accountNumber" component="div" className="invalid-feedback" />
                                        </div>
                                    </>
                                )}

                                {values.settlementType === "BANK" && (
                                    <>
                                        <div className="col-md-4">
                                            <label htmlFor="bankName" className="form-label fw-semibold">
                                                Bank Name <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                name="bankName"
                                                type="text"
                                                value={productUnderwriter?.bankName || ""}
                                                onChange={(e) => handleProductUnderwriterChange(e, setFieldValue)}
                                                className={`form-control ${errors.bankName && touched.bankName ? "is-invalid" : ""}`}
                                                placeholder="Enter bank name"
                                            />
                                            <ErrorMessage name="bankName" component="div" className="invalid-feedback" />
                                        </div>
                                        <div className="col-md-4">
                                            <label htmlFor="accountNumber" className="form-label fw-semibold">
                                                Account Number <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                name="accountNumber"
                                                type="text"
                                                value={productUnderwriter?.accountNumber || ""}
                                                onChange={(e) => handleProductUnderwriterChange(e, setFieldValue)}
                                                className={`form-control ${errors.accountNumber && touched.accountNumber ? "is-invalid" : ""}`}
                                                placeholder="Enter account number"
                                            />
                                            <ErrorMessage name="accountNumber" component="div" className="invalid-feedback" />
                                        </div>
                                        <div className="col-md-4">
                                            <label htmlFor="branch" className="form-label fw-semibold">
                                                Branch <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                name="branch"
                                                type="text"
                                                value={productUnderwriter?.branch || ""}
                                                onChange={(e) => handleProductUnderwriterChange(e, setFieldValue)}
                                                className={`form-control ${errors.branch && touched.branch ? "is-invalid" : ""}`}
                                                placeholder="Enter branch"
                                            />
                                            <ErrorMessage name="branch" component="div" className="invalid-feedback" />
                                        </div>
                                    </>
                                )}

                                {/* Settlement Frequency with Threshold */}
                                <div className="col-12">
                                    <label className="form-label fw-semibold my-3">Settlement Frequency</label>
                                    <div className="d-flex gap-8 mb-3" style={{ gap: "2rem" }}>
                                        <div className="form-check">
                                            <input
                                                type="radio"
                                                name="settlementFrequency"
                                                value="EOD"
                                                checked={values.settlementFrequency === "EOD"}
                                                onChange={(e) => handleProductUnderwriterChange(e, setFieldValue)}
                                                className="form-check-input"
                                                id="eodRadio"
                                            />
                                            <label className="form-check-label" htmlFor="eodRadio">End of Day (EOD)</label>
                                        </div>
                                        <div className="form-check">
                                            <input
                                                type="radio"
                                                name="settlementFrequency"
                                                value="WEEKLY"
                                                checked={values.settlementFrequency === "WEEKLY"}
                                                onChange={(e) => handleProductUnderwriterChange(e, setFieldValue)}
                                                className="form-check-input"
                                                id="weeklyRadio"
                                            />
                                            <label className="form-check-label" htmlFor="weeklyRadio">Weekly</label>
                                        </div>
                                        <div className="form-check">
                                            <input
                                                type="radio"
                                                name="settlementFrequency"
                                                value="MONTHLY"
                                                checked={values.settlementFrequency === "MONTHLY"}
                                                onChange={(e) => handleProductUnderwriterChange(e, setFieldValue)}
                                                className="form-check-input"
                                                id="monthlyRadio"
                                            />
                                            <label className="form-check-label" htmlFor="monthlyRadio">Monthly</label>
                                        </div>
                                        <div className="form-check">
                                            <input
                                                type="radio"
                                                name="settlementFrequency"
                                                value="THRESHOLD"
                                                checked={values.settlementFrequency === "THRESHOLD"}
                                                onChange={(e) => handleProductUnderwriterChange(e, setFieldValue)}
                                                className="form-check-input"
                                                id="thresholdRadio"
                                            />
                                            <label className="form-check-label" htmlFor="thresholdRadio">Threshold</label>
                                        </div>
                                    </div>
                                    <ErrorMessage name="settlementFrequency" component="div" className="invalid-feedback d-block" />

                                    {/* Threshold Amount Field */}
                                    {values.settlementFrequency === "THRESHOLD" && (
                                        <div className="row mt-3">
                                            <div className="col-md-6">
                                                <label htmlFor="threshold" className="form-label fw-semibold">
                                                    Threshold Amount <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    name="threshold"
                                                    type="number"
                                                    value={productUnderwriter?.threshold || ""}
                                                    onChange={(e) => handleProductUnderwriterChange(e, setFieldValue)}
                                                    className={`form-control ${errors.threshold && touched.threshold ? "is-invalid" : ""}`}
                                                    placeholder="Enter threshold amount"
                                                />
                                                <ErrorMessage name="threshold" component="div" className="invalid-feedback" />
                                                <div className="form-text">Settlement will occur when this threshold amount is reached</div>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* Submit Button */}
                                <div className="col-12">
                                    <div className="d-flex justify-content-end mt-4 pt-3 border-top">
                                        <button type="button" onClick={modalClose} className="btn btn-outline-secondary me-3 px-4">
                                            Cancel
                                        </button>
                                        <button
                                            type="submit"
                                            disabled={productUnderwriter?.loading || isMyUnderwritersLoading || emails.length === 0}
                                            className="btn btn-success px-4 py-2 d-flex align-items-center"
                                        >
                                            {productUnderwriter?.loading && (
                                                <div className="spinner-border spinner-border-sm me-2" role="status">
                                                    <span className="visually-hidden">.</span>
                                                </div>
                                            )}
                                            {productUnderwriter?.loading ? "Please wait..." : "Save Underwriter"}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>
            )}
        </div>
    );
}